import type { RouteRecordRaw } from 'vue-router'
import { check } from '../guards/permission'
import type { Empty } from './types'

export interface RouteParams {
    home: Empty
    'home.ddq': Empty
}

/**
 * Home route for the new nested structure
 */
export const homeRoutes: RouteRecordRaw[] = [
    {
        path: 'home',
        component: () => import('@/vue/pages/home/Layout.vue'),
        beforeEnter: check([], 'dashboard', 'new-homepage'),
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('@/vue/pages/lumi/LumiPage.vue'),
                meta: {
                    title: 'Lumi AI',
                    fluid: true,
                },
            },
            {
                path: 'ddq',
                name: 'home.ddq',
                component: () => import('@/vue/pages/DDQResponsePage.vue'),
                meta: {
                    editMode: false,
                    title: 'general.ddq.page-title',
                    fluid: true,
                    showEditModeToggle: false,
                    hideSubNavigation: false,
                    feature: {
                        flag: 'ai-ddq-response-generator',
                        fallbackRoute: 'home',
                    },
                },
            },
        ],
    },
]
